import React, { useCallback, useMemo } from 'react'
import { Button } from 'semantic-ui-react'
import '../style.scss'
import { selectAllQuarterlyTaxEstimateDetailsSorted } from '../../quarterly-tax-estimate-details/quarterlyTaxEstimateDetails.selector'
import { useReselector } from '@/utils/sharedHooks'

interface Props {
  onDateChange: (_params: {
    selectedQuarter: string
    selectedYear: string
  }) => void
  selectedYear: string
  selectedQuarter: string
}

const sortAscending = (values: string[]) =>
  [...values].sort((a, b) => Number(a) - Number(b))

const CalculationDateToolbar: React.FC<Props> = ({
  onDateChange,
  selectedYear,
  selectedQuarter,
}) => {
  const allQuarterlyTaxEstimateDetails = useReselector(
    selectAllQuarterlyTaxEstimateDetailsSorted
  )

  const calendarYears = useMemo(
    () =>
      sortAscending(
        Array.from(
          new Set(
            allQuarterlyTaxEstimateDetails.map((detail) => detail.taxYear)
          )
        )
      ),
    [allQuarterlyTaxEstimateDetails]
  )

  const getQuarters = useCallback(
    (year: string) =>
      sortAscending(
        allQuarterlyTaxEstimateDetails
          .filter((detail) => detail.taxYear === year)
          .map((detail) => detail.taxQuarter)
      ),
    [allQuarterlyTaxEstimateDetails]
  )

  const calendarQuarters = useMemo(
    () => getQuarters(selectedYear),
    [getQuarters, selectedYear]
  )

  return (
    <>
      {calendarYears.length === 0 && <p>No Calendar Years to display</p>}
      {calendarYears.length > 0 && (
        <div>
          <Button.Group>
            {calendarYears.map((y) => (
              <Button
                active={selectedYear === y}
                content={`${y} Calendar Year`}
                key={`button-${y}`}
                onClick={() => {
                  onDateChange({
                    selectedYear: y,
                    selectedQuarter: getQuarters(y)[0] ?? '',
                  })
                }}
              />
            ))}
          </Button.Group>
        </div>
      )}
      {calendarQuarters && calendarQuarters.length > 0 && (
        <div>
          <Button.Group>
            {calendarQuarters.map((q) => (
              <Button
                active={selectedQuarter === q}
                content={q}
                key={`button-${q}`}
                onClick={() =>
                  onDateChange({ selectedQuarter: q, selectedYear })
                }
              />
            ))}
          </Button.Group>
        </div>
      )}
    </>
  )
}

export default CalculationDateToolbar
